import {InterpolationPrimitive} from "@emotion/serialize";
import {Theme} from "@emotion/react";

type Style = InterpolationPrimitive;

type BrandStyleFn<BrandTheme> = (theme: BrandTheme) => Style;

type BrandStyle<BrandTheme> = BrandStyleFn<BrandTheme> | Style;

export type ForBrandObject = {
  crossBrand?: BrandStyle<Theme>;
  at?: BrandStyle<Theme>;
  br?: BrandStyle<Theme>;
  brfs?: BrandStyle<Theme>;
  hc?: BrandStyle<Theme>;
  gap?: BrandStyle<Theme>;
  gapfs?: BrandStyle<Theme>;
  on?: BrandStyle<Theme>;
  default?: BrandStyle<Theme>;
};

export function resolveStyles<Theme>(
  theme: Theme,
  brandStyles?: BrandStyle<Theme>
): Style {
  if (typeof brandStyles === "function") return brandStyles(theme);
  return brandStyles;
}

/**
 * forBrands - output styles specific to brand
 * @param {Object}: Theme object from React-Stitch
 * @param {Object}: Pass theme functions with brand keys e.g. at: theme => theme.color.b1
 * @returns a style as a string or css object which can be used with Emotion styled components or css prop
 */
export const forBrands = (
  theme: Theme,
  brandStyles: ForBrandObject,
  crossBrand?: boolean
): Style => {
  const stitchTheme = theme;
  let style: Style;
  switch (stitchTheme.brand) {
    case "at":
      style = resolveStyles(stitchTheme, brandStyles.at);
      break;
    case "br":
      style = resolveStyles(stitchTheme, brandStyles.br);
      break;
    case "brfs":
      style = resolveStyles(stitchTheme, brandStyles.brfs);
      break;
    case "hc":
      style = resolveStyles(stitchTheme, brandStyles.hc);
      break;
    case "gap":
      style = resolveStyles(stitchTheme, brandStyles.gap);
      break;
    case "gapfs":
      style = resolveStyles(stitchTheme, brandStyles.gapfs);
      break;
    case "on":
      style = resolveStyles(stitchTheme, brandStyles.on);
      break;
    default:
      break;
  }
  if (crossBrand) style = resolveStyles(theme, brandStyles.crossBrand);
  const defaultStyle = resolveStyles(theme, brandStyles.default);
  return style ?? defaultStyle;
};
